import { useState } from "react";
import { ShieldAlert, X } from "lucide-react";
import type { MfaPflichtHinweis } from "../../../../shared/types.js";

/**
 * Hinweis fuer GF/Admin ohne 2FA waehrend der Einrichtungsfrist.
 * Nach Ablauf der Frist ist keine Anmeldung ohne 2FA mehr moeglich.
 */
export function MfaPflichtBanner({ hinweis }: { hinweis: MfaPflichtHinweis | null | undefined }) {
  const [closed, setClosed] = useState(false);
  if (!hinweis || closed) return null;
  const datum = new Date(hinweis.fristBis).toLocaleDateString("de-DE");
  const tage = hinweis.restTage === 1 ? "1 Tag" : `${hinweis.restTage} Tage`;
  return (
    <div
      role="alert"
      data-testid="mfa-pflicht-banner"
      style={{
        position: "fixed", top: 52, left: "50%", transform: "translateX(-50%)", zIndex: 60,
        maxWidth: "min(640px, calc(100vw - 24px))",
        display: "flex", alignItems: "center", gap: 10,
        padding: "10px 14px", borderRadius: 8,
        background: "rgba(245, 166, 35, 0.16)", border: "1px solid rgba(245, 166, 35, 0.5)",
        color: "var(--color-foreground, #fff)", fontSize: 13, backdropFilter: "blur(6px)",
      }}
    >
      <ShieldAlert size={16} style={{ flexShrink: 0, color: "#f5a623" }} />
      <span>
        2FA ist fuer deine Rolle Pflicht. Noch {tage} (bis {datum}), danach ist keine Anmeldung ohne 2FA moeglich.{" "}
        <a href="#/hub/konto" style={{ color: "#6DCFF6", textDecoration: "underline" }}>Jetzt einrichten</a>
      </span>
      <button type="button" aria-label="Hinweis schliessen" onClick={() => setClosed(true)} style={{ color: "inherit", opacity: 0.7 }}>
        <X size={14} />
      </button>
    </div>
  );
}
